<template>
  <div class="modal-sm modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Выдача скидки</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="alert alert-success my-1" v-if="this.region">
        Текущая скидка: {{this.region.sale}}
      </div>
      <div v-if="regionData" class="modal-body">
        <input-form-custom
          name="count"
          v-model="regionData.sale"
          label="Размер скидки"
          :rule="{ required: true, regex: /^[0-9]{1,6}([.][0-9]{1,2})?$/ }"
          class="mb-3"
          inputClass="form-control"
        />
        <label class="input-group">
          <span class="input-group-prepend"><span class="input-group-text">До (не вкл., до 00:00)</span></span>
          <datepicker v-model="regionData.date"></datepicker>
        </label>
      </div>
      <div class="alert alert-danger my-1" v-if="validationError">
        {{validationError}}
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <btn-action
          class="btn btn-primary"
          @click="save"
        >Выдать</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import {pick, cloneDeep} from 'lodash'

  export default {
    props: ['region'],
    data () {
      return {
        regionData: {
            region: this.region
        },
        validationError: '',
        balance: 0,
      }
    },
    methods: {
      save () {
        this.balance = Number(this.regionData.count) + Number(this.region.money)
        api.post(`billing/regions/give-discount/`, {sale: this.regionData.sale, date: this.regionData.date, region_id: this.region.id})
        .then(({data}) => {
              this.hide(false)
              window.alert(`Скидка успешно выдана \n Текущая скидка: ${this.regionData.sale} % \n До: ${this.regionData.date} (не включительно, до 00:00)`)
            })
        .catch(this.handleError)
      },
      hide (refresh = false) {
        this.$emit('hide', {
          refresh: refresh,
        })
      },
      handleError (error) {
        if (error.response && error.response.status === 422) {
          let obj = error.response.data.validation
          this.validationError = obj[Object.keys(obj)[0]][0]
        } else {
          throw error
        }
      },
    },
    mounted () {
      if (this.user) {
        this.regionData = pick(this.user, ['count'])
      } else {
        this.regionData = {
            count: '',
          }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/billing/modals/region-give-discount.vue